module.exports = __webpack_public_path__ + "img/folders.b75fa017.png";